import React from 'react';
import SectionMenuBar, { SectionMenuBarReducer } from '../../../components/section-menu/show-and-hide';
import { questions } from './data/questions';
import { UrlService } from '../../../core/services/UrlService';
import Layout from '../../../components/layout';
import Seo from '../../../components/seo';
import './index.scss';
import Hero from './components/hero';
import $ from 'jquery';
import SelfTestSection from '../../../components/self-test/SelfTestSection';
import SelfTestResult from './components/self-test-result';
import ReferenceListSection from '../../../components/reference-list/ReferenceListSection';
import { useCmsCampaign } from '../../../cms/hooks/useCmsCampaign';
import config from './data/config';

const AdpkdSelfTest: React.FC = () => {
    const [state, dispatch] = React.useReducer(SectionMenuBarReducer, {
        anchorId: 'intro',
    });

    const [isInit, setIsInit] = React.useState(true);

    const { campaign, layoutConfig, seoConfig } = useCmsCampaign('bipolar-disease');

    React.useEffect(() => {
        if (isInit) {
            setIsInit(false);
        } else {
            $("html, body").animate({ scrollTop: $('.self-test__content-sections').position()?.top - 150 || 0 }, 600);
        }
    }, [state]);

    return (
        <Layout {...layoutConfig}>
            <Seo {...seoConfig}></Seo>

            <div className="self-test self-test_bipolar-disease">
                <Hero
                    reducer={[state, dispatch]}
                />
                <section className="self-test__content-sections">
                    <div className="container self-test__content-container">
                        <div className="self-test__content-text-container">

                            <h2><span className="important">躁鬱症</span>是甚麼？</h2>
                            <p>
                                躁鬱症(Bipolar Disorder)是狂躁抑鬱症的簡稱。
                                患者會不斷重複進入「抑鬱」、「躁狂」及兩者混合的情緒。
                                鬱期時，患者會持續情緒低落，甚至無法應付日常生活。當進入狂躁期，患者的情緒會完全轉變，感覺極度良好及興奮。
                                這種狀態會影響患者思考能力和判斷力，做出自大、不切實際，甚至災難性的決定。
                                生理上，患者也會變得精力充沛，出現難以入睡、性慾加強等症狀<sup>2</sup>。
                                患者有時亦會出現兩者混合的情緒，如感到抑鬱，同時出現躁狂期間的坐立不安及過度活躍<sup>1</sup>。
                            </p>
                            <p>
                                躁鬱症的成因至今未明，研究發現是因為腦部的化學物質（如血清素）失去平衡所致，導致腦部控制情緒的部分出現問題。
                                至今醫學仍未能完全解釋失衡的原因，有機會是因遺傳、生病、生活壓力等影響<sup>2</sup>。
                            </p>
                            <p>
                                治療躁鬱症需要從生活習慣、心理治療及藥物三方面入手。良好生活習慣，如均衡飲食有助預防病發<sup>2</sup>。
                                心理治療有助患者監察、處理自己的情緒<sup>1</sup>。
                                藥物治療亦十分重要，可助患者控制情緒。據統計，服藥可減少3至4成復發現象<sup>1</sup>。
                                情緒穩定劑，如鋰鹽(Lithium)，是最先發現有效情緒穩定劑。鋰鹽是一種天然的物質，可穩定患者情緒，減少患者徘佪在抑鬱和狂躁的兩極情緒<sup>1</sup>。
                                另外，精神病治療藥物（如喹硫平）亦用於治療精神分裂和躁鬱症症狀，不但有鎮靜作用，還可以減少幻覺、妄想等嚴重躁鬱症症狀<sup>3</sup>。
                            </p>
                        </div>
                        <div className="self-test__content-image-container">
                            <div className="self-test__content-image">
                                <img src={UrlService.getLocalImageUrl('self-test/bipolar-disease/content-img-1.png')}></img>
                                <label>
                                    只有約<br />
                                    <span className="huge">1成</span>香港人<br />
                                    受情緒困擾時願意向專業人士求助<sup>4</sup>
                                </label>
                            </div>
                            <div className="self-test__content-image">
                                <img src={UrlService.getLocalImageUrl('self-test/bipolar-disease/content-img-2.png?2')}></img>
                                <label>
                                    躁鬱症發病年齡大多在<br />
                                    青年至成年時期，<br />
                                    <span className="huge">40歲</span>以上人士較少發病<sup>1</sup>
                                </label>
                            </div>
                            <div className="self-test__content-image">
                                <img src={UrlService.getLocalImageUrl('self-test/bipolar-disease/content-img-3.png')}></img>
                                <label>
                                    服藥可減少<br />
                                    <span className="huge">3至4成</span><br />
                                    復發現象<sup>1</sup>
                                </label>
                            </div>
                        </div>
                    </div>
                </section>
                <SelfTestSection
                    id='測試'
                    questions={questions}
                    result={SelfTestResult}
                />
                <ReferenceListSection references={campaign.data?.references ?? config.defaultReferences} />
                <section>
                    <div className="container">
                        <p className="mini">
                            本網頁由ZP Therapeutics支持製作。
                            此自我測驗謹供學術或參考用途，並非提供任何醫療意見或建議任何商品或服務，亦不可取代任何診斷或治療。
                            有關您個人的治療情況，請諮詢您的醫生為您作出準確的診斷，並提供適合的治療。
                            我們建議您攜帶您的測試結果，協助您及您的醫生、護士或藥劑師全面有效地掌握您的疾病情況。
                        </p>
                    </div>
                </section>
            </div>
        </Layout>
    );
};

export default AdpkdSelfTest;
